import gmx_zMixins         from '../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_Watching           from './Watching'
import lmx_Events             from './Events'

// Charts 
import lmx_localData          from '../primitives/localData'
import lmx_LocalValues        from './set_LocalValues'
import lmx_draw_Forms         from './draw_Forms'

import lmx_diagram_Draw       from './diagram_Draw'
import lmx_diagram_Stage      from './diagram_Stage'
import lmx_diagram_Forms      from './diagram_Forms'
import lmx_diagram_Elements   from './diagram_Elements'
import lmx_diagram_Actions    from './diagram_Actions'

import lmx_data_Draw          from './data_Draw'
import lmx_data_Forms         from './data_Forms'
import lmx_data_Elements      from './data_Elements'
import lmx_data_Actions       from './data_Actions'

import lmx_Popup              from './Popup'


export default {
  
  mixins: [
    gmx_zMixins, 

    // Local Mixins
    lmx_localData,
    lmx_Events,
    lmx_Watching,
    
    lmx_LocalValues,
    lmx_draw_Forms,
    
    // Diagram
    lmx_diagram_Draw,
    lmx_diagram_Stage,
    lmx_diagram_Forms,
    lmx_diagram_Elements,
    lmx_diagram_Actions,

    // DataList
    lmx_data_Draw,
    lmx_data_Forms,
    lmx_data_Elements,
    lmx_data_Actions,

    
    lmx_Popup,
  ],

}
